import { PlatformColor, Platform } from "react-native";
import { Material3Color, Material3DynamicColor } from "./materialColor";
export * from "./android.dynamic.types";
export * from "./android.material.types";
export * from "./ios.types";
var iosColor = new Proxy({}, {
  get(_, prop) {
    if (Platform.OS === "ios") return PlatformColor(prop);
    return null;
  }
});
var androidMaterialColor = new Proxy({}, {
  get(_, prop) {
    if (Platform.OS === "android") return Material3Color(prop);
    return null;
  }
});
var androidDynamicColor = new Proxy({}, {
  get(_, prop) {
    if (Platform.OS === "android") return Material3DynamicColor(prop);
    return null;
  }
});
var androidColor = new Proxy({
  get material() {
    return androidMaterialColor;
  },
  get dynamic() {
    return androidDynamicColor;
  }
}, {
  get(target, prop) {
    if (prop in target) return target[prop];
    if (Platform.OS === "android") return PlatformColor("@android:color/" + prop);
    return null;
  }
});
var Color = {
  get ios() {
    return iosColor;
  },
  get android() {
    return androidColor;
  }
};
export {
  Color
};
//# sourceMappingURL=index.native.js.map
